'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdMoveToInbox = function MdMoveToInbox(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm26.6 16.6l-6.6 6.8-6.6-6.8h3.2v-5h6.8v5h3.2z m5 8.4v-16.6h-23.3v16.6h6.7q0 2 1.5 3.5t3.5 1.5 3.5-1.5 1.5-3.5h6.6z m0-20q1.4 0 2.4 1t1 2.4v23.2q0 1.4-1 2.4t-2.4 1h-23.3q-1.4 0-2.4-1t-0.9-2.4v-23.2q0-1.4 0.9-2.4t2.4-1h23.3z' })
        )
    );
};

exports.default = MdMoveToInbox;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/move-to-inbox.js
// module id = 3567
// module chunks = 168707334958949